import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import Loading from 'components/Loading'
import modules from './modules'

export default function(route) {
  const Result = Loadable({
    loader: () => import('./Login'),
    render(loaded, props) {
      console.log(loaded, 'loaded-2')
      console.log(props, 'props-2')
      const Component = connect((state) => ({
        payPageResultState: state.payPageResultState,
        siteConfig: state.siteConfig
      }), {
        // init,
        // fetchBanner,
        // setCardResultVisible
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Result {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
